import React, { useEffect } from "react";
import "./Clientspage.css";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Clientslistpage from "./Clientslistpage";
import Clientspageheading from "./Clientspageheading";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

function Clientspage() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Our Clients | Trusted by Global Brands - Dwebbox</title>
        <meta
          name="description"
          content="View the global brands and startups that trust Dwebbox for their software development needs. We've delivered premium solutions for clients worldwide."
        />
        <link rel="canonical" href="https://dwebbox.com/clients" />
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://dwebbox.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Clients",
                "item": "https://dwebbox.com/clients"
              }
            ]
          })}
        </script>
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Clientspageheading />
      <Clientslistpage />
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Clientspage;
